import axios from "../../config/axiosClient";
import Config from "../../config/Config.js";


// --------------------------------------------
// core authentication functionality 
// --------------------------------------------

// Helper function to choose storage type based on "remember me"
const getStorage = (rememberMe) => rememberMe ? localStorage : sessionStorage;


// hits API to authenticate user
const SIGN_IN = (creds, rememberMe = false) => {
  const email = creds.email;
  const password = creds.password;
  axios
  .post(
    `${Config().signinUrl}`,     
    {
      email: email,
      password: password
    }    
  )
  .then(res => {
    const token = res.data.key;
    console.log(res);
    GET_USER_DATA_AFTER_API_AUTH(creds, token, "/home", rememberMe);
  })
  .catch(err => {
    console.error('SIGN_IN Error:', err);
    console.error('SIGN_IN Error Response:', err.response);
    console.error('SIGN_IN Error Status:', err.response?.status);
    console.error('SIGN_IN Error Data:', err.response?.data);
    
    try {
      const errMsgs = err.response.data;
      const keys = Object.keys(errMsgs);
      if (keys.length < 2) {
        for (const key of keys) {
          alert(errMsgs[key])
        }
      } else if (keys.length === 1) {
        alert(errMsgs[keys])
      }
    } catch (error) {
      console.error('SIGN_IN Error parsing response:', error);
      alert('Authentication failed. Please check your credentials and try again.');
    }
  });
}


// Gets user data upon authentication
const GET_USER_DATA_AFTER_API_AUTH = (creds, token, redirect_to, rememberMe = false) => {
  axios
    .get(
      Config().userAuthUrl,
      { headers: { Authorization: `Token ${token}` } }
    )
    .then(res => {
      const user_data = res.data;
      const storage = getStorage(rememberMe);

      storage.setItem("TOKEN", token);
      storage.setItem("USER_PK", user_data.id || user_data.pk);
      storage.setItem("USERNAME", user_data.username);
      storage.setItem("USER_EMAIL", user_data.email);
      storage.setItem("USER_FIRST_NAME", user_data.first_name);
      storage.setItem("USER_LAST_NAME", user_data.last_name);
      storage.setItem("IS_AUTHENTICATED", true);
      console.log(`Auth stored in ${rememberMe ? 'localStorage' : 'sessionStorage'}`);
      window.location = redirect_to;
    })
    .catch(err => {
      console.error('GET_USER_DATA_AFTER_API_AUTH Error:', err);
      alert('Failed to retrieve user data after authentication. Please try signing in again.');
    })
}


// creates new user, prompts user to confirm email
const SIGN_UP = (creds) => {
  axios
    .post(`${Config().signupUrl}`, {
      username: creds.username,
      email: creds.email,
      password1: creds.password1,
      password2: creds.password2
    })
    .then(res => {
      const token = res.data.key;
      if(token !== null){
        localStorage.setItem("USER_EMAIL", creds.email);
        window.location = "/accounts/confirm";
      }
    })
    .catch(err => {
      console.error('SIGN_UP Error:', err);
      console.error('SIGN_UP Error Response:', err.response);
      console.error('SIGN_UP Error Status:', err.response?.status);
      console.error('SIGN_UP Error Data:', err.response?.data);
      
      try {
        const errMsgs = err.response.data;
        const keys = Object.keys(errMsgs);
    
        if (keys.length < 2) {
          for (const key of keys) {
            alert(errMsgs[key])
          }
        } else if (keys.length === 1) {
          alert(errMsgs[keys])
        }
      } catch (error) {
        console.error('SIGN_UP Error parsing response:', error);
        alert('Sign up failed. Please check your information and try again.');
      }
    });
};


// clears localStorage, signing out user
const SIGN_OUT = (token) => {
  axios
    .post(
      `${Config().signoutUrl}`,
      {},
      {
        headers: {
          Authorization: `Token ${token}`
        }
      }
    )
    .then(res => {
      console.log('SIGN_OUT Success:', res);
    })
    .catch(err => {
      console.error('SIGN_OUT Error:', err);
      console.error('SIGN_OUT Error Response:', err.response);
      console.error('SIGN_OUT Error Status:', err.response?.status);
      console.error('SIGN_OUT Error Data:', err.response?.data);
    })
    .finally(() => {
      // Clear both storage types regardless of API success/failure
      localStorage.clear();
      sessionStorage.clear();
      localStorage.setItem("IS_AUTHENTICATED", false);
      window.location.href = "/";
    });
};


// resets password, step 1/2
const PASSWORD_RESET_1 = (email) => {
  console.log('Attempting password reset for:', email);
  console.log('Reset URL:', Config().pwdResetUrl);
  
  axios
    .post(
      `${Config().pwdResetUrl}`,
      {'email': email}
    )
    .then(res => {
      console.log('Password reset response:', res);
      alert(res.data.detail || 'Password reset email sent successfully!');
    })
    .catch(err => {
      console.error('Password reset error:', err);
      console.error('Error response:', err.response);
      
      if (err.response?.status === 500) {
        alert('Server error occurred. The password reset feature may not be configured properly. Please contact support.');
      } else if (err.response?.status === 400) {
        alert(err.response.data?.email?.[0] || 'Invalid email address.');
      } else if (err.response?.data?.detail) {
        alert(err.response.data.detail);
      } else {
        alert('Failed to send password reset email. Please try again or contact support.');
      }
    });
};

// resets password, step 2/2
const PASSWORD_RESET_2 = (new_password1, new_password2, uid, token) => {
  axios
    .post(
      `${Config().pwdResetConfirmUrl}`,
      {
        'new_password1' : new_password1,
        'new_password2' : new_password2,
        'uid' : uid,
        'token' : token
      }
    )
    .then(res => {
      console.log('PASSWORD_RESET_2 Success:', res);
      alert(res.data.detail);
    })
    .catch(err => {
      console.error('PASSWORD_RESET_2 Error:', err);
      console.error('PASSWORD_RESET_2 Error Response:', err.response);
      console.error('PASSWORD_RESET_2 Error Status:', err.response?.status);
      console.error('PASSWORD_RESET_2 Error Data:', err.response?.data);
      
      if (err.response?.status === 400) {
        alert(err.response.data?.detail || 'Invalid password reset data. Please try again.');
      } else if (err.response?.status === 500) {
        alert('Server error occurred during password reset. Please try again later or contact support.');
      } else {
        alert('Password reset failed. Please try again or contact support.');
      }
    });
};


// determines authentication data from localStorage or sessionStorage
const RESOLVE_LOCAL_AUTH_STATE = () => {
  // Check both storage types, prioritize localStorage (persistent)
  const checkStorage = (key) => localStorage.getItem(key) || sessionStorage.getItem(key);
  
  return {
    is_authenticated: checkStorage("IS_AUTHENTICATED"),
    token: checkStorage("TOKEN"),
    username: checkStorage("USERNAME")
  };
};


// determines user data from localStorage or sessionStorage
const RESOLVE_LOCAL_USER_STATE = () => {
  // Check both storage types, prioritize localStorage (persistent)
  const checkStorage = (key) => localStorage.getItem(key) || sessionStorage.getItem(key);
  
  return {
    username: checkStorage("USERNAME"),
    pk: checkStorage("USER_PK"),
    email: checkStorage("USER_EMAIL"),
    first_name: checkStorage("USER_FIRST_NAME"),
    last_name: checkStorage("USER_LAST_NAME")
  };
};

// Validates current token against the API. Clears storage if invalid.
const VALIDATE_TOKEN = async () => {
  const auth = RESOLVE_LOCAL_AUTH_STATE();
  if (auth.is_authenticated !== 'true' || !auth.token) return false;

  try {
    await axios.get(Config().userAuthUrl, {
      headers: { Authorization: `Token ${auth.token}` },
    });
    return true;
  } catch (err) {
    if (err.response?.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      localStorage.setItem('IS_AUTHENTICATED', 'false');
      return false;
    }
    // Network error or server error — don't log out, just return true
    return true;
  }
};

export {
  SIGN_UP,
  SIGN_IN,
  SIGN_OUT,
  PASSWORD_RESET_1,
  PASSWORD_RESET_2,
  RESOLVE_LOCAL_AUTH_STATE,
  RESOLVE_LOCAL_USER_STATE,
  VALIDATE_TOKEN,
};